
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './en.json';
import swe from './swe.json';
  
i18n.use(initReactI18next).init({
    compatibilityJSON: 'v3',
  lng: 'swe',
  fallbackLng: 'swe',
  resources: {
    en: en,
    swe: swe,
  },
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});
  
export default i18n;